import { Asset } from '@/types/swagger';
import { PayloadAction, UnknownAction } from '@reduxjs/toolkit';
import { getNewImmutableState } from 'util/getNewImmutableState';

// Action Types
export const LOAD_ASSETS = 'assets/load_assets';
export const ASSETS_FETCHING = 'assets/assets_fetching';

// Action Creators
export const loadAssets = (assets: Record<number, Asset>) => ({
  type: LOAD_ASSETS,
  payload: assets,
});
export const assetsFetching = (fetchStatus: string) => ({
  type: ASSETS_FETCHING,
  payload: fetchStatus,
});
// ----------------------------------- Reducer ---------------------------------
interface AssetsState {
  byId: Record<number, any>;
  allIds: number[];
  allNamesById: Record<number, string>;
  isFetching: string;
}

// Init State
export const INIT_STATE: AssetsState = {
  byId: {},
  allIds: [],
  allNamesById: {},
  isFetching: 'idle',
};

const reducer = (state = INIT_STATE, action: UnknownAction): AssetsState => {
  const { type, payload } = action as PayloadAction<Asset[] | string>;
  switch (type) {
    case LOAD_ASSETS: {
      return {
        ...state,
        ...getNewImmutableState(state, payload),
        allNamesById: Object.fromEntries(
          Object.entries(payload).map(([id, asset]) => [id, asset.name])
        ),
      };
    }
    case ASSETS_FETCHING: {
      return {
        ...state,
        isFetching: payload as string,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
